import { DemoExample } from "@/components/sections/DemoSection";

export const backgroundChangeDemo: DemoExample = {
    label: "Background Change",
    beforeImage: "/images/demos/animal-demo/animal-demo-before.webp",
    beforeImageSrcSet: "/images/demos/animal-demo/animal-demo-before-400w.webp 400w, /images/demos/animal-demo/animal-demo-before-800w.webp 800w, /images/demos/animal-demo/animal-demo-before-1200w.webp 1200w",
    afterImage: "/images/demos/animal-demo/animal-demo-after.webp",
    afterImageSrcSet: "/images/demos/animal-demo/animal-demo-after-400w.webp 400w, /images/demos/animal-demo/animal-demo-after-800w.webp 800w, /images/demos/animal-demo/animal-demo-after-1200w.webp 1200w",
    title: "Change Photo Background",
    description: "Move your pet from indoors to a beautiful outdoor park.",
    alt: "Before and after changing background from interior to park"
};

export const beagleBackgroundChangeDemo: DemoExample = {
    label: "Background Change",
    beforeImage: "/images/demos/beagle/beagle-couch-before.webp",
    beforeImageSrcSet: "/images/demos/beagle/beagle-couch-before-400w.webp 400w, /images/demos/beagle/beagle-couch-before-800w.webp 800w",
    afterImage: "/images/demos/beagle/beagle-park-after.webp",
    afterImageSrcSet: "/images/demos/beagle/beagle-park-after-400w.webp 400w, /images/demos/beagle/beagle-park-after-800w.webp 800w",
    title: "Change Dog Background from Couch to Park",
    description: "Transform your pet's setting from indoors to a natural outdoor environment.",
    alt: "Before and after changing beagle background from couch to park"
};

export const backgroundBlurDemo: DemoExample = {
    label: "Background Blur",
    beforeImage: "/images/demos/blur/blur-before.webp",
    afterImage: "/images/demos/blur/blur-after.webp",
    title: "DSLR Background Blur",
    description: "Add professional depth of field and bokeh to your portraits.",
    alt: "Before and after background blur effect"
};

export const productBackgroundRemovalDemo: DemoExample = {
    label: "Product Background Removal",
    beforeImage: "/images/demos/background-removal/product-shoe-before.png",
    afterImage: "/images/demos/background-removal/product-shoe-before.png", // Placeholder: After image generation failed due to quota
    title: "Clean Product Photography",
    description: "Remove distracting backgrounds to make your product stand out for e-commerce.",
    alt: "Before and after removing background from a product photo"
};

export const portraitBackgroundRemovalDemo: DemoExample = {
    label: "Portrait Background Removal",
    beforeImage: "/images/demos/background-removal/portrait-woman-before.png",
    afterImage: "/images/demos/background-removal/portrait-woman-before.png", // Placeholder: After image generation failed due to quota
    title: "Isolate Subjects",
    description: "Perfectly extract subjects from complex backgrounds for professional use.",
    alt: "Before and after removing background from a portrait"
};
